import appLogo from '../assets/honey_branding/01 - Transparent SVG (1).svg';

export const APP_NAME = 'Honey';
export const APP_LOGO_SRC = appLogo;